let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hNzr3")).then(() => parcelRequire('jmnEC'));